import { Routes } from '@angular/router';
import { AccountOwnerGuard } from '@usheru-hff/authentication/domain';
import { CollectionRoutesEnum } from '@usheru-hff/shared/utils-community';

export const COLLECTIONS_ROUTES: Routes = [
  {
    path: CollectionRoutesEnum.COLLECTION_LISTS,
    loadComponent: () => import('@usheru-hff/collections/lists-collection').then(m => m.ListsCollectionComponent)
  },
  {
    path: CollectionRoutesEnum.COLLECTION_LIST,
    loadComponent: () => import('@usheru-hff/collections/list-collection').then(m => m.ListCollectionComponent)
  },
  {
    path: CollectionRoutesEnum.COLLECTION_TAGS_IN_TAGTYPE,
    loadComponent: () => import('@usheru-hff/collections/tags-collection').then(m => m.TagsCollectionComponent)
  },
  {
    path: CollectionRoutesEnum.COLLECTION_STREAMING,
    loadComponent: () => import('@usheru-hff/collections/streaming-platforms').then(m => m.StreamingCollectionComponent)
  },
  {
    path: CollectionRoutesEnum.COLLECTION_USERS,
    loadComponent: () => import('@usheru-hff/collections/users').then(m => m.UsersCollectionComponent)
  },
  {
    path: 'user-activity',
    loadChildren: () => import('@usheru-hff/user-activity').then(m => m.UserActivityModule)
  },
  {
    path: CollectionRoutesEnum.MY_ACTIVITY_WISHLIST,
    loadComponent: () =>
      import('@usheru-hff/collections/my-activity/wishlist').then(m => m.WishlistCollectionComponent),
    canActivate: [AccountOwnerGuard]
  },
  {
    path: CollectionRoutesEnum.MY_ACTIVITY_SEEN,
    loadComponent: () => import('@usheru-hff/collections/my-activity/seen').then(m => m.WatchedCollectionComponent),
    canActivate: [AccountOwnerGuard]
  },
  {
    path: CollectionRoutesEnum.MY_ACTIVITY_STREAMING_PLATFORMS,
    loadComponent: () =>
      import('@usheru-hff/collections/my-activity/streaming-platforms').then(m => m.StreamingCollectionComponent),
    canActivate: [AccountOwnerGuard]
  },
  {
    path: CollectionRoutesEnum.MY_ACTIVITY_LISTS,
    loadComponent: () => import('@usheru-hff/collections/my-activity/lists').then(m => m.MyListCollectionComponent),
    canActivate: [AccountOwnerGuard]
  },
  {
    path: CollectionRoutesEnum.MY_ACTIVITY_FOLLOWED_LISTS,
    loadComponent: () =>
      import('@usheru-hff/collections/my-activity/followed-lists').then(m => m.FollowedListsCollectionComponent),
    canActivate: [AccountOwnerGuard]
  },
  {
    path: CollectionRoutesEnum.MY_ACTIVITY_TAGS,
    loadComponent: () =>
      import('@usheru-hff/collections/my-activity/tags').then(m => m.TagsFollowedCollectionComponent),
    canActivate: [AccountOwnerGuard],
    data: { isEditable: true }
  }
];
